import { useEffect } from "react";
import { useColorMode } from "@shared/hooks/useColorMode";
import StageService from "@shared/modules/seating/services/StageService";

/**
 * Syncs the seating map's location background colors with the active theme.
 *
 * Konva canvas shapes don't react to CSS variable changes, so when the user
 * toggles light/dark mode this hook re-reads the themed CSS variable and
 * updates every location-bg shape on the stage.
 */
export function useSeatingThemeSync(
  stageService: StageService | undefined
): void {
  const { colorMode } = useColorMode();

  useEffect(() => {
    stageService?.updateLocationBackgroundColors();
  }, [colorMode, stageService]);
}
